"use client";

import { Zap, MessageSquare, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function FeaturesGrid() {
  const features = [{
    id: 1,
    icon: Zap,
    title: "Aurora Excellence",
    description: "Enjoy significantly more square footage and modern floor plans in established neighborhoods just minutes from the Naperville border."
  }, {
    id: 2,
    icon: MessageSquare,
    title: "Plainfield Living",
    description: "Discover vibrant community parks and top-rated schools with spacious, new-construction homes that fit your budget perfectly."
  }, {
    id: 3,
    icon: TrendingUp,
    title: "Oswego & Bolingbrook",
    description: "The perfect balance of commuter convenience and suburban peace, offering luxury finishes and large lots for under $650K."
  }];
  return <section id="featuresgrid" className="bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {}
        <div className="mb-16 text-center">
          <h2 className="font-default text-3xl md:text-4xl font-bold text-foreground mb-4">
            Smart Moves Beyond Naperville
          </h2>
          <p className="font-default text-base md:text-lg text-foreground/80 max-w-2xl mx-auto">
            Discover premier neighboring communities offering modern amenities
            and the extra room to breathe you've been searching for.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={feature.id} data-index={i}>
                <Card className="h-full flex flex-col border border-border shadow">
                  <CardHeader className="flex flex-col items-center text-center gap-4">
                    {}
                    <div className="flex items-center justify-center w-16 h-16 rounded-lg" style={{
                  border: "2px solid var(--accent-gold)"
                }}>
                      <Icon size={28} style={{
                    color: "var(--accent-gold)"
                  }} strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl font-bold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="font-default text-sm text-foreground/70 leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}